module.exports = "/packs/media/images/icons/icon_lifestyle-8a6861c8a7eaa223224c311d72cbb1d5.png";